import { useTranslation } from 'react-i18next';
import { useRef, useState } from 'react';
import './style.css';
import { ImgPopup } from '@/components/Exporter';
import { CRIcon } from '@/components/crRender';
import { Icon } from '@iconify/react/dist/iconify.js';

const MedicalDocuments = ({ admissionDetails }) => {
    const { t } = useTranslation();
    const [viewingDocument, setViewingDocument] = useState("test");
    const [viewAll, setViewAll] = useState(false);
    const imgRef = useRef(null);
    const flatFiles = admissionDetails?.patientData?.files?.flatMap(file => (file?.data));

    const handleViewDocument = (doc) => {
        if (doc.name.includes("pdf")) {
            window.open(`${window.API_URL}${doc.name}`, "_blank");
            return;
        }
        setViewingDocument(doc.name);
        imgRef.current.click();
    };

    const getFileIcon = (name) => {
        let type = name.split('.')[1]?.toLowerCase();

        if(type === 'pdf') return <Icon className="medical-document-icon-pdf" color="#dc2626" icon="fluent:document-pdf-16-filled" width="25" height="25" />;
        if(type === 'excel') return <Icon className="medical-document-icon-excel" color="#059669" icon="mdi:file-excel-box" width="25" height="25" />;
        if(type === 'doc' || type === 'docx') return <Icon className="medical-document-icon-doc" color="#2563eb" icon="mdi:file-word-box" width="25" height="25" />;
        if( ["png" , "jpg" , "jpeg"].includes(type)) return <Icon className="medical-document-icon-image" color="#f59e0b" icon="tabler:photo-filled" width="25" height="25" />;
    };


    const handleViewAll = () => {
        setViewAll(prev=>!prev);
    };

    return (
        <>
            <div className="medical-documents-section">
                <h2 className="medical-documents-title">
                    <div>
                        <Icon icon="solar:file-text-line-duotone" width="18" height="18" />
                        {t('medical-documents')}
                    </div>
                    <div className="medical-documents-view-all-container" onClick={handleViewAll}>
                        <span className="medical-documents-view-all" >{!viewAll ? t("see-more") : t("see-less")}</span>
                        <Icon icon={viewAll ? "mdi:chevron-up" : "mdi:chevron-down"} width="20" height="20" />
                    </div>
                </h2>

                <div className="medical-documents-list">
                    {flatFiles?.filter(doc => doc.name?.split('/')[0] != 'passport')?.slice(0, viewAll ? undefined : 3)?.map((doc) => (
                        <div key={doc.id} className="medical-document-item" onClick={() => handleViewDocument(doc)}>
                           <div className="medical-document-icon"> {getFileIcon(doc.name)}</div>
                            <div className="medical-document-info">
                                <div className="medical-document-name">{t(doc.name?.split('/')[0])}</div>
                                <div className="medical-document-size pointer">{t("click-to-open")}</div>
                            </div>
                            <CRIcon onClick={() => handleViewDocument(doc)} icon="iconoir:eye-solid" className="medical-document-eye-icon" />
                        </div>
                    ))}
                </div>
            </div>
            <ImgPopup isHideText link={viewingDocument} refImg={imgRef} />
        </>
    );
};

export default MedicalDocuments;

